import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import transformFeatureData from '../utility/transformFeatureData'

// Redux type and action creators
const { Types, Creators } = createActions({
  tablePanelToggled: [],
  tablesReset: [],
  tableDataUpdated: ['featureData'],
  tableRenderToggled: ['tableName'],
  tableRenderRemoved: ['tableName'],
  reset: []
})

export const TableTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  tablePanelOpen: false,
  tablesRendered: [],
  data: {}
})

// Redux reducers
export const tablePanelToggled = state => {
  const { tablePanelOpen } = state

  return state.merge({ tablePanelOpen: !tablePanelOpen })
}

export const tableRenderToggled = (state, { tableName }) => {
  const { tablesRendered } = state
  const nextTablesRendered =
    tablesRendered.indexOf(tableName) >= 0
      ? tablesRendered.filter(table => table !== tableName)
      : [tableName, ...tablesRendered]
  return state.merge({ tablesRendered: nextTablesRendered })
}

export const tableRenderRemoved = (state, { tableName }) => {
  console.log('removing', tableName)
  const { tablesRendered } = state
  const nextTablesRendered = tablesRendered.filter(table => table !== tableName)
  return state.merge({ tablesRendered: nextTablesRendered })
}

export const tableDataUpdated = (state, { featureData }) => {
  const { data } = state
  const nextData = transformFeatureData(featureData)
  console.log(Object.keys(nextData))
  const nextTablesRendered = Object.keys(nextData)
  return state.merge({
    data: data.merge(nextData),
    tablesRendered: nextTablesRendered
  })
}

export const tablesReset = state => {
  return INITIAL_STATE
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.TABLE_PANEL_TOGGLED]: tablePanelToggled,
  [Types.TABLE_RENDER_TOGGLED]: tableRenderToggled,
  [Types.TABLE_RENDER_REMOVED]: tableRenderRemoved,
  [Types.TABLE_DATA_UPDATED]: tableDataUpdated,
  [Types.TABLES_RESET]: tablesReset,
  [Types.RESET]: tablesReset
})



// WEBPACK FOOTER //
// ./src/redux/tableRedux.js